import { useMemo, Activity } from "react";
import styles from "./navigationPanel.module.css";
import { NavList } from "./navList/navList";
import { BottomActions } from "./bottomActions";
import {
  contentNavItems,
  userNavItems,
  appNavItems,
  replaceUsernamePlaceholder,
} from "../../constants/navigationItems";
import { useNavigationPanel } from "../../hooks/context/useNavigationPanel";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { useUser } from "../../hooks";

export function NavigationPanel() {
  const { close } = useNavigationPanel();
  const isDesktop = useMediaQuery("(min-width: 620px)");

  const { isLoggedIn: isUserLoggedIn, user } = useUser();
  const handleNavClick = useMemo(
    () => (isDesktop ? undefined : close),
    [isDesktop, close],
  );

  const processedUserNavItems = useMemo(() => {
    if (!user?.username) return userNavItems;
    return replaceUsernamePlaceholder(userNavItems, user.username);
  }, [user?.username]);

  return (
    <nav className={styles.navPanel} aria-label="Main navigation">
      <div className={styles.navContent}>
        <div className={styles.navListGroup}>
          <NavList
            items={contentNavItems}
            onNavClick={handleNavClick}
            ariaLabel="Content types"
          />
          <Activity mode={isUserLoggedIn ? "visible" : "hidden"}>
            <NavList
              items={processedUserNavItems}
              onNavClick={handleNavClick}
              ariaLabel="Your content"
            />
          </Activity>
          <NavList
            items={appNavItems}
            onNavClick={handleNavClick}
            ariaLabel="Application"
          />
        </div>
        <BottomActions />
      </div>
    </nav>
  );
}
